import HomePage from "./HomePage";
import WithLayout from "src/Components/Layout/Layout";

export default WithLayout(HomePage);